module.exports = __webpack_public_path__ + "img/phone-bg-bottom.c49f0828.png";